///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/viewmodels/transformers/create/defaults"/>
function noop() {

}

export const maxProperty = noop;
export const construct = noop;
export const finalize = noop;
export const shouldDescend = true;